// To use the sandbox, simply create a new file in /sandbox and import it here.
// The sandbox is a great way to showcase and test more complex demos without
// having to build out a new docs page each time.

import Sandbox from '../sandbox/GlobalNav'
export default Sandbox
